import { useEffect, useMemo } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { OAuth2 } from '../../services/McDataServices'
import { getUserDetailsAndProcess } from '../../services/DataServiceMethods'
import { useGlobalStoreActions, useGlobalStoreData } from '../../store/globalStore'
import { useToast } from './useToast'

export const useGmailOAuth = (t) => {
  const location = useLocation()
  const navigate = useNavigate()

  const { showSuccess, showError } = useToast()

  const { setUserData } = useGlobalStoreActions()
  const user = useGlobalStoreData.user()

  const params = useMemo(() => new URLSearchParams(location.search), [location.search])

  const code = useMemo(() => params.get('code'), [params])
  const state = useMemo(() => params.get('state'), [params])

  useEffect(() => {
    if (!code || !state) return

    const handleGmailCallback = async () => {
      try {
        const response = await OAuth2.GmailCallback({ code, state })

        if (response) {
          getUserDetailsAndProcess(true, user, setUserData, true)
          showSuccess(t('gmail.success'))
        } else {
          showError(t('gmail.error'))
        }
      } catch (err) {
        showError(t('gmail.error'))
      } finally {
        const currentPath = location.pathname
        navigate(currentPath, { replace: true })
      }
    }

    handleGmailCallback()
  }, [code, state, showSuccess, showError, t, navigate, location.pathname, user, setUserData])

  return { code, state }
}
